import React from 'react'
import { FaFileAlt } from 'react-icons/fa'

const AdminInputFileList = ({ inputFiles, onClickDeleteFile }) => {
    return (
        <ul>
            {Array.from(inputFiles).map((file, index) => {
                return (
                    <li key={'inputFileItem' + index} className='file-list__item'>
                        <div className='file-list__filename'>
                            <FaFileAlt />&nbsp;{file.name}
                        </div>
                        <div className='file-list__button'>
                            <button type='button' className='btn btn-sm text-danger' onClick={() => onClickDeleteFile(index)}>X</button>
                        </div>
                    </li>
                )

            })}
        </ul>
    )
}

export default AdminInputFileList